import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-1 w-full mb-5" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickWalletWithdraw && _ctx.btnClickWalletWithdraw(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'wallet:withdraw'}, "flex justify-center items-center w-full text-center cursor-pointer opacity-95"])
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-withdrawl_result.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickWalletDepositAuto && _ctx.btnClickWalletDepositAuto(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'wallet:deposit'}, "flex justify-center items-center w-full text-center cursor-pointer opacity-95"])
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-deposit_result.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickTransactionDeposit && _ctx.btnClickTransactionDeposit(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'wallet:transaction'}, "flex justify-center items-center w-full text-center cursor-pointer opacity-95"])
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-history_result.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickUpdateBank && _ctx.btnClickUpdateBank(...args))),
      type: "button",
      class: _normalizeClass([{'opacity-100': _ctx.session.get('navbar_sub') === 'wallet:update'}, "flex justify-center items-center w-full text-center cursor-pointer opacity-95"])
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("img", {
        src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-profile_result.webp",
        alt: "",
        class: ""
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */)
  ]))
}